import React from 'react';
import SVG from 'react-inlinesvg';
import Resizable from 're-resizable';
import { connect } from 'react-redux';

import './index.css';
import { toggleFormsModal } from '../../actions';
import FormIdea from '../../components/formIdea';
import TechnologiesCarousel from '../../components/technologiesCarousel';
import laptop from '../../images/mobile/mobiles.png';
import mobile from '../../images/mobile/mobile.png';
import experience from '../../images/mobile/experience.svg';
import quality from '../../images/mobile/quality.svg';
import support from '../../images/mobile/support.svg';
import time from '../../images/mobile/time.svg';
import interaction from '../../images/mobile/interaction.svg';
import rights from '../../images/mobile/rights.svg';
import mobileShape from '../../images/mobile/mobile-shape.png';
import mobileScreen from '../../images/mobile/mobile-screen.png';
import resize from '../../images/mobile/resize.svg';
import mobileTop from '../../images/mobile/mobile-top.svg';

class Mobile extends React.Component {

  render() {
    return (
      <div className="mobile page">
        <div className="mobile__preview__footer">
          <div className="mobile__preview__footer__wrapper">
            <span className="mobile__preview__footer__leo">CREATIVE PROJECT IS LEO</span>
            <div className="mobile__preview__footer__links">

              <a target="_blank" rel="noopener noreferrer" href="https://www.behance.net/leotrado8901" className="mobile__preview__footer__social">behance</a>
              <a target="_blank" rel="noopener noreferrer" href="https://www.pinterest.ru/leotrado/" className="mobile__preview__footer__social">pinterest</a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2Fgroups%2F249633105595577%2F" className="mobile__preview__footer__social">facebook</a>
            </div>
          </div>
        </div>
        <div className="mobile__preview">
          <div className="mobile__preview__info">
            <h1>mobile</h1>
            <div className="subtitle">{ localStorage.getItem('lang') == 'ru'? 'Разработка мобильных приложений любой сложности iOS | Android':'Development of any complexity of iOS | Android'}</div>
          </div>
        </div>
        <div className="mobile__development">
            <img className="mobile__development__laptop" src={this.props.clientWidth > 540 ? laptop : mobile} alt="" />
            <div className="mobile__development__container">
                   <div className="mobile__development__item">
              <SVG src={experience} />
              <h3 className="mobile__development__item__title">{ localStorage.getItem('lang') == 'ru'? 'Опыт':'Experience'}</h3>
              <p className="mobile__development__item__description">
              { localStorage.getItem('lang') == 'ru'? 'Наши заслуги признают более 1000000 пользователей, мы не останавливаемся на достигнутом и ставим перед собой новые цели.':
              'Our merits are recognized by more than 1,000,000 users.'}
                 
              </p>
            </div>
            <div className="mobile__development__item">
              <SVG src={quality} />
              <h3 className="mobile__development__item__title">{ localStorage.getItem('lang') == 'ru'? 'Качество':'Quality'}</h3>
              <p className="mobile__development__item__description">
              { localStorage.getItem('lang') == 'ru'? 'Каждый шаг при работе над проектом четко выверен и взвешен, поскольку к разработке мы привлекаем только опытных профессионалов успевших себя зарекомендовать.':
              'Every step of the project is carefully calibrated and considered, because we involve only experienced professionals who have proved their worth.'}
                </p>
            </div>
            <div className="mobile__development__item">
              <SVG src={support} />
              <h3 className="mobile__development__item__title">{ localStorage.getItem('lang') == 'ru'? 'Поддержка':'Support'}</h3>
              <p className="mobile__development__item__description">
              { localStorage.getItem('lang') == 'ru'? 'Техническая поддержка - не просто пустые слова. Каждый проект для нас как ребенок, и как заботливый родитель мы готовы его оберегать и заботится о нем. Улучшая и совершенствуя продукт.':
              'Technical support is not just empty words. Every project for us is like a child, and we as a caring parent are ready to protect it and take care of it. Improving and perfecting the product.'}
                
              </p>
            </div>
            </div>
          </div>
        <div className="mobile__methods">
          <div className="mobile__methods__background" />
          <div className="mobile__methods__section">
            <div className="mobile__methods__item">
              <div>
                <SVG src={time} className="mobile__methods__item__icon" />
                <span className="mobile__methods__item__title">{ localStorage.getItem('lang') == 'ru'? 'Быстрый старт проекта':'Quick start'}</span>
              </div>
              <p className="mobile__methods__item__description">
              { localStorage.getItem('lang') == 'ru'? 'Мы готовы начать разработку без детального описания требований, детали будут видны в процессе разработки.':
              'We are ready to start development even without detailed requirements but based on a clear vision of the mobile application.'}
                
              </p>
            </div>
            <div className="mobile__methods__item">
              <div>
                <SVG src={rights} className="mobile__methods__item__icon" />
                <span className="mobile__methods__item__title">{ localStorage.getItem('lang') == 'ru'? 'Активное взаимодействие':'Active interaction'}</span>
              </div>
              <p className="mobile__methods__item__description">
              { localStorage.getItem('lang') == 'ru'? 'Коммуникации с клиентом в рамках единой команды, мы учитываем мнение заказчика на каждом шагу проектирования.':
              'Communication with the client within the framework of a single team, we take into account the client’s opinion at every stage of the design.'}
                
              </p>
            </div>
            <div className="mobile__methods__item">
              <div>
                <SVG src={interaction} className="mobile__methods__item__icon" />
                <span className="mobile__methods__item__title">{ localStorage.getItem('lang') == 'ru'? 'Современные технологии':'Modern technologies'}</span>
              </div>
              <p className="mobile__methods__item__description">
              { localStorage.getItem('lang') == 'ru'? 'В работе используем только современные технологии, благодаря этому приложение легко не только поддерживать, но и развивать на протяжении многих лет.':
              'We use only state-of-the-art technologies in our work, which makes it easy not only to maintain, but also to develop the application over many years.'}
                
              </p>
            </div>
          </div>
          <div className="mobile__methods__info">
            <h2 className="mobile__methods__info__title">
              { localStorage.getItem('lang') == 'ru'? 'Разработка мобильных приложений любой сложности iOS | Android':
              'Development of any complexity of iOS | Android'}</h2>
            <span className="mobile__methods__underline"></span>
            <p>
              {localStorage.getItem('lang') == 'ru'? 'В компании Leo Trado мы предлагаем полный спектр по разработке мобильных приложений: от UX дизайна до полного развертывания на платформах Android и iOS.':
              'Leo Trado oﬀers a full range of mobile applications development from UX design to full deployment on Android and iOS platforms.'}  
            </p>
            <p>
              {localStorage.getItem('lang') == 'ru'? 'Разрабатывая приложение мы полностью погружаеся в проект для того, чтобы предвидеть все желания пользователей, создать интуитивно понятный и функциональный интерфейс.':
              'By developing the application we are completely immersed in the project in order to anticipate all the wishes of the users, create an intuitive and functional interface.'}
            </p>
          </div>
        </div>
        <TechnologiesCarousel
          tech="mobile"
          openQrModal={() => this.props.toggleFormsModal(true, 'qr')}
          redirectToPortfolio={() => this.props.history.push('/portfolio')} />
        <div className="mobile__approach">
          <div className="mobile__approach__info">
            <h2 className="mobile__approach__title">{ localStorage.getItem('lang') == 'ru'? 'Наш подход к созданию приложения':'Our approach to creating an application'}</h2>
            <div className="mobile__approach__scrollContainer">
              <div className="mobile__approach__wrapper">
                <div className="mobile__approach__info__col">
                  <div
                    className="mobile__approach__item"
                    style={{ marginBottom: '97px' }}>
                    <div>
                      <div className="mobile__approach__item__icon">
                        <span className="mobile__approach__item__step">1</span>
                      </div>
                      <span className="mobile__approach__item__title">{ localStorage.getItem('lang') == 'ru'? 'Постановка задачи':'Setting a target'}</span>
                    </div>
                    <p className="mobile__approach__item__description">
                      { localStorage.getItem('lang') == 'ru'? 'Внимательно вникаем в суть вашей идеи, уточняем и развиваем её.':'We take a close look to thr essence of your idea, refine it and develop it'}
                      
                    </p>
                  </div>
                  <div
                    className="mobile__approach__item"
                    style={{ marginBottom: '97px' }}>
                    <div>
                      <div className="mobile__approach__item__icon">
                        <span className="mobile__approach__item__step">2</span>
                      </div>
                      <span className="mobile__approach__item__title">{localStorage.getItem('lang') == 'ru'? 'Прототипирование':'Prototyping'}</span>
                    </div>
                    <p className="mobile__approach__item__description">
                    {localStorage.getItem('lang') == 'ru'? 'Создаем архитектуру вашего проекта - проектируем модель нывигации, экраны состояний приложения и другие элементы интерфейса.':
                    'We create the architecture of your project - design the model of the nagging, the screens of the states of the application and other elements of the interface.'}
                      
                  </p>
                  </div>
                  <div className="mobile__approach__item">
                    <div>
                      <div className="mobile__approach__item__icon">
                        <span className="mobile__approach__item__step">3</span>
                      </div>
                      <span className="mobile__approach__item__title">{localStorage.getItem('lang') == 'ru'? 'Дизайн':'Design'}</span>
                    </div>
                    <p className="mobile__approach__item__description">
                      {localStorage.getItem('lang') == 'ru'? 'На основане прототипов разрабатываем конечный вид приложения. Не забывая про фирменный стиль приложения.':
                      'Based on the prototypes the ﬁnal application type is developed. Not forgetting the proprietary style of the application.'}
                      
                  </p>
                  </div>
                </div>
                <div className="mobile__approach__phone">
                  <SVG src={mobileTop} className="mobile__approach__phone__top" />
                  <img src={mobileShape} alt="" className="mobile__approach__phone__background" />
                  <img src={mobileScreen} alt="" className="mobile__approach__phone__screen" />
                  <div
                    style={{
                      width: '363px',
                      height: '737px',
                      position: 'relative',
                      borderRadius: '112px',
                      overflow: 'hidden'
                    }}
                    className="mobile__approach__phone__shape">
                    <Resizable
                      defaultSize={{
                        width: 100,
                        height: 696,
                      }}
                      enable={{
                        top: false,
                        right: true,
                        bottom: false,
                        left: false,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false
                      }}
                      className="mobile__approach__phone__overlay">
                      <SVG src={resize} className="mobile__approach__phone__resize" />
                    </Resizable>
                  </div>
                </div>
                <div className="mobile__approach__info__col mobile__approach__info__col__second">
                  <div className="mobile__approach__item">
                    <div>
                      <div className="mobile__approach__item__icon">
                        <span className="mobile__approach__item__step">4</span>
                      </div>
                      <span className="mobile__approach__item__title">{localStorage.getItem('lang') == 'ru'? 'Разработка':'Development'}</span>
                    </div>
                    <p className="mobile__approach__item__description">
                    {localStorage.getItem('lang') == 'ru'? 'Проектируем базу данных на основе анализа исходных параметров. Создаем систему управления, настраиваем сервер и прочие функции.':
                    'We design a database based on a baseline analysis. Create a control system, conﬁgure a server and other functions.'}
                      
                  </p>
                  </div>
                  <div className="mobile__approach__item">
                    <div>
                      <div className="mobile__approach__item__icon">
                        <span className="mobile__approach__item__step">5</span>
                      </div>
                      <span className="mobile__approach__item__title">{localStorage.getItem('lang') == 'ru'? 'Тестирование':'Testing'}</span>
                    </div>
                    <p className="mobile__approach__item__description">
                    {localStorage.getItem('lang') == 'ru'? 'Бета-тестирование приложения проводится на различных версиях платформ и гаджетов.':
                    'Beta testing of the application is performed on diﬀerent versions of platforms and gadgets.'}
                      
                  </p>
                  </div>
                  <div className="mobile__approach__item">
                    <div>
                      <div className="mobile__approach__item__icon">
                        <span className="mobile__approach__item__step">6</span>
                      </div>
                      <span className="mobile__approach__item__title">{localStorage.getItem('lang') == 'ru'? 'Запуск и поддержка':'Launching and support'}</span>
                    </div>
                    <p className="mobile__approach__item__description">
                    {localStorage.getItem('lang') == 'ru'? 'Публикуем готовое приложение. Оперативно собираем отзывы пользователей, выявляем малейшие недочеты, улучшаем сервис.':
                    'We publish a ready-made application. We quickly collect user feedback, identify any shortcomings, improve the service.'}
                      
                  </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FormIdea theme="dark" />
      </div>
    )
  }
}

const mapStateToProps = ({ clientWidth }) => {
  return {
    clientWidth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleFormsModal: (flag, tab) => dispatch(toggleFormsModal(flag, tab))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Mobile)



// WEBPACK FOOTER //
// ./src/pages/mobile/index.jsx